module.exports = {
    SOLUTIONS: {
        WEBSITE: {
            label: 'Insurance Agency Website',
            description: 'An amazing website with everything your agency needs to attract and convert insurance buyers online.',
            price: 170,
            discountedPrice: 130,
            mse: true,
        },
        SEO_BUNDLE: {
            label: 'Ultimate SEO Bundle',
            description: 'An amazing website with everything your agency needs to attract and convert insurance buyers online.',
            price: 265,
            // discountedPrice: 250,
            savings: 25,
            includes: [ 'WEBSITE', 'LLM', 'RRM' ],
            mse: true,
        },
        RRM: {
            label: 'Reviews & Reputation Management',
            description: 'Grow, nurture, and protect your agency\'s online reputation.',
            // requires: [
            //     'WEBSITE',
            // ],
            price: 110,
          //  discountedPrice: 80,
            mse: true,
        },
        LLM: {
            label: 'Local Listing Management',
            description: 'Get found across the web so consumers can reach your agency, with or without visiting your website.',
            // requires: [
            //     'WEBSITE',
            // ],
            price: 50,
         //   discountedPrice: 50,
            mse: true,
        },
        SMM: {
            label: 'Social Media Marketing',
            description: 'Tell your story and build relationships with BrightFire\'s Social Media Marketing.',
            price: 100,
            mse: true,
        },
        PPC: {
            label: 'Search Engine Marketing',
            description: 'Improve your online visibility, increase engagement, boost brand awareness, and most importantly, encourage your online prospects to take action.',
            price: 160,
         //   discountedPrice: 150,
        },
    },
    ORDER: [
        'WEBSITE',
        'SEO_BUNDLE',
        'LLM',
        'RRM',
        'SMM',
        'PPC',
    ],
    ENDPOINTS: {
        email: process.env.REACT_APP_EMAIL_ENDPOINT,
        log: process.env.REACT_APP_QUOTE_LOG_ENDPOINT,
        quote: process.env.REACT_APP_QUOTE_GET_ENDPOINT,
    },
    REF: {
        checkoutBase: process.env.REACT_APP_ERIE_CHECKOUT_BASE
    }
};
